module.exports = __webpack_public_path__ + "static/media/x.a24b9e8b.svg";